import request from '@/router/axios';

//登录接口
export const login = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/login',
    method: 'get',
    params: {
      ...data
    }
  })
}

//获取授权码接口
export const authorize = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/authorize',
    method: 'get',
    params: {
      ...data
    }
  })
}

//获取token接口
export const token = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/token',
    method: 'post',
    params: data
  })
}
//测试接口
export const searchStatisticsList = (data) => {
  return request({
    url: 'v1/demo/searchStatisticsList',
    method: 'get',
    params: data
  })
}

export default {
  login,
  authorize,
  token,
  searchStatisticsList
}



// WEBPACK FOOTER //
// ./src/api/login.js